module.exports = __webpack_public_path__ + "img/1.25748694.jpg";